import { render } from "./Actualites.vue?vue&type=template&id=7c20779a&scoped=true&ts=true"
import script from "./Actualites.vue?vue&type=script&lang=ts"
export * from "./Actualites.vue?vue&type=script&lang=ts"

import "./Actualites.vue?vue&type=style&index=0&id=7c20779a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c20779a"]])

export default __exports__